import React from "react";
import {
  Card, CardHeader, CardBody, Container, Form, FormGroup, Col, Label, Media,
} from "reactstrap";
import SimpleHeader from "@/components/Headers/SimpleHeader";
import { Link } from "react-router";
import Select from "react-select";
import CountryAccessDisplayContainer from "./adding-user/CountryAccessDisplayContainer";
import type { SelectOption } from "@/utils/selectOptions";

/** The user being edited, as the header and the per-country blocks read it. */
type PermissionUser = {
  name?: string;
  avatar?: string;
  permission?: { CountryCode?: string; siteId?: unknown }[];
};

export type EditPermissionViewProps = {
  userHeader?: PermissionUser;
  countrycode: SelectOption[];
  countriesOptions: readonly SelectOption[];
  onSelectCountries: (selected: SelectOption[] | null) => void;
  onFinish: React.MouseEventHandler<HTMLButtonElement>;
};

const EditPermissionView = ({
  userHeader,
  countrycode,
  countriesOptions,
  onSelectCountries,
  onFinish,
}: EditPermissionViewProps) => (
  <>
    <SimpleHeader name="Update Permission" parentName="Users" />
    <Container className="mt--6" fluid>
      <Card>
        <CardHeader className="text-center">
          <Media className="align-items-center">
            <span className="avatar avatar-sm rounded-circle">
              {/* SCRUM-660: guard PUBLIC_URL — "" historically, but undefined under
                  Vite (process.env shimmed to {}), which would yield
                  "undefined/Images/…". `|| ""` keeps the src at "/Images/…". */}
              <img
                alt="..."
                src={(process.env.PUBLIC_URL || "") + "/Images/" + (userHeader?.avatar || "")}
              />
            </span>
            <Media className="ml-2 d-none d-lg-block">
              <span className="mb-0 text-sm font-weight-bold">
                {userHeader?.name}
              </span>
            </Media>
          </Media>
          <h3 className="mb-0">Edit {userHeader?.name} permission</h3>
        </CardHeader>

        <CardBody className="text-center">
          <Form>
            <FormGroup className="row">
              <Label className="form-control-label" md="2">
                Select Country Access
              </Label>
              <Col md="10">
                <Select
                  isMulti
                  value={countrycode}
                  options={countriesOptions}
                  className="basic-multi-select"
                  classNamePrefix="select"
                  // react-select hands a readonly array; the container stores that same array.
                  onChange={(selected) => onSelectCountries(selected as SelectOption[])}
                />
              </Col>
            </FormGroup>
          </Form>

          {Array.isArray(countrycode) && countrycode.map(c => (
            <CountryAccessDisplayContainer
              key={c.value}
              name={c.label}
              value={c.value}
              oldPermissionUpdateForm={userHeader?.permission || []}
            />
          ))}

          <button
            className="btn btn-outline-primary mr-1 float-right"
            type="submit"
            onClick={onFinish}
          >
            Finish Updating
          </button>

          <Link to="/admin/users" className="btn btn-outline-default mr-1 float-left">
            Back To Users
          </Link>
        </CardBody>
      </Card>
    </Container>
  </>
);

export default EditPermissionView;
